import React from 'react';
import './style.css';
import Button from "../Button";
import classNames from "classnames";

const MobileButton = ({clickHandler}) =>
    <Button classnames={classNames("btn mobile-button ellipse")} handler={clickHandler}>
        <div>...</div>
    </Button>

MobileButton.default =  {
    clickHandler: () => {}
}

export default MobileButton;